import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import { PageLayoutContext } from './Contexts';
import HeaderFrame from './HeaderFrameContainer';

const { element } = bem('column-layout');

const Column = ({ index, children, className, isDesktop, back, type }) => (
  <PageLayoutContext.Consumer>
    {({ layoutInfo: { isFixedPage } }) => (
      <div className={element('column', { isFixedPage }, className)}>
        {/* in "mobile" mode, each Column gets its own HeaderFrame and columns have built-in spacing
          in "desktop" mode, there's just 1 HeaderFrame for the page and columns have no built-in spacing */}
        {isDesktop ? (
          children
        ) : (
          <HeaderFrame index={index} back={back}>
            <div className={element('mobile-column-spacer', { [type]: true })}>{children}</div>
          </HeaderFrame>
        )}
      </div>
    )}
  </PageLayoutContext.Consumer>
);

Column.displayName = 'Column';

Column.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  type: PropTypes.oneOf(['standard', 'flush', 'public']),
  isDesktop: PropTypes.bool,
  index: PropTypes.number,
  back: PropTypes.func,
};

export default Column;
